<template>
  <div v-if="showItemComputed">
    <router-link
      class="nav-item nav-link"
      v-bind:to="item.to"
      v-bind:replace="replace"
    >
      {{ item.name }}
      <span v-if="shouldNotify" class="blink-opacity">
        <b-icon-exclamation-circle-fill class="ml-1" />
      </span>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NavbarItem",
  props: {
    item: {},
    replace: {
      default: false
    }
  },
  computed: {
    shouldNotify() {
      if (this.item.notificationGetter == undefined) {
        return false;
      }

      if (this.isActive) {
        return false;
      }

      return this.$store.getters[this.item.notificationGetter];
    },
    isActive() {
      return this.$route.path.startsWith(this.item.to);
    },
    requiresLogin() {
      if (this.item.requiresLogin === undefined) {
        return false;
      }

      return this.item.requiresLogin;
    },
    showItemComputed() {
      if (!this.$store.getters.isLoggedIn && this.requiresLogin) {
        return false;
      }

      if (isNaN(this.item.requiredRole)) {
        return true;
      }

      return this.item.requiredRole <= this.$store.state.userRole;
    }
  }
};
</script>
